var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _g3, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 433,
    viewBox: "0 0 441 433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.801 0.0980055C115.152 -3.22835 17.5737 78.5094 2.83146 185.76C-13.2871 303.023 75.4276 408.532 184.588 425.431C320.364 446.45 452.06 324.851 440.235 192.934C431.326 93.546 342.311 3.47931 227.801 0.0980055Z",
    fill: "#F4F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199.921 319.601C215.744 308.427 218.573 279.157 214.699 259.514C210.176 236.58 198.33 235.973 196.2 217.863C192.234 184.145 231.672 172.424 230.369 138.103C229.304 110.047 202.543 107.234 202.778 76.1103C202.947 53.6517 216.962 44.3215 210.667 24.7247C210.129 23.0494 204.066 5.06564 188.707 0.862272C173.205 -3.37999 157.299 8.89763 149.433 18.7872C134.893 37.0677 145.656 49.916 136.373 77.9117C123.733 116.027 96.3008 114.773 92.7948 144.762C89.8995 169.526 107.937 176.092 104.182 203.486C100.694 228.924 83.8734 232.505 83.167 249.843C81.5417 289.73 167.646 342.391 199.921 319.601Z",
    fill: "url(#paint0_linear_492_558)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_492_558",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 0,
    width: 148,
    height: 326
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.921 319.601C215.744 308.427 218.573 279.157 214.699 259.514C210.176 236.58 198.33 235.973 196.2 217.863C192.234 184.145 231.672 172.424 230.369 138.103C229.304 110.047 202.543 107.234 202.778 76.1103C202.947 53.6517 216.962 44.3215 210.667 24.7247C210.129 23.0494 204.066 5.06564 188.707 0.862272C173.205 -3.37999 157.299 8.89763 149.433 18.7872C134.893 37.0677 145.656 49.916 136.373 77.9117C123.733 116.027 96.3008 114.773 92.7948 144.762C89.8995 169.526 107.937 176.092 104.182 203.486C100.694 228.924 83.8734 232.505 83.167 249.843C81.5417 289.73 167.646 342.391 199.921 319.601Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_492_558)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.103 338.337C177.009 338.337 176.914 338.313 176.828 338.262C161.975 329.538 149.599 318.089 140.043 304.233C130.979 291.09 121.608 277.501 122.364 260.506C122.939 247.574 128.956 240.666 136.573 231.921C143.836 223.582 152.875 213.204 159.199 193.984C162.808 183.013 167.301 169.359 163.837 153.013C161.827 143.526 158.115 138.157 154.839 133.421C151.409 128.46 148.447 124.176 149.013 116.827C149.919 105.053 156.207 97.534 163.488 88.8275C167.904 83.5474 172.469 78.0876 176.473 70.997C187.729 51.0634 188.027 24.2275 177.361 -8.76487C177.268 -9.05073 177.425 -9.35742 177.711 -9.44987C177.997 -9.54279 178.304 -9.3852 178.396 -9.0995C189.16 24.1943 188.832 51.3227 177.421 71.5321C173.368 78.7095 168.77 84.208 164.323 89.5256C157.162 98.0887 150.978 105.484 150.098 116.91C149.561 123.875 152.285 127.814 155.734 132.802C159.068 137.623 162.846 143.087 164.902 152.787C168.426 169.42 163.883 183.229 160.232 194.324C153.84 213.753 144.721 224.223 137.394 232.635C129.916 241.221 124.009 248.002 123.451 260.554C122.711 277.184 131.977 290.62 140.937 303.614C150.404 317.34 162.664 328.681 177.379 337.324C177.638 337.476 177.725 337.81 177.572 338.069C177.471 338.241 177.289 338.337 177.103 338.337Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.478 161.327C165.329 161.327 165.18 161.266 165.072 161.146C164.872 160.922 164.892 160.578 165.115 160.378C190.284 137.889 202.11 117.024 207.598 103.482C213.542 88.815 213.539 79.3405 213.538 79.2466C213.536 78.9461 213.778 78.7007 214.078 78.6982C214.079 78.6982 214.081 78.6982 214.082 78.6982C214.38 78.6982 214.624 78.9386 214.626 79.2374C214.63 79.6279 214.641 88.9706 208.635 103.82C203.108 117.486 191.197 138.532 165.841 161.189C165.737 161.282 165.607 161.327 165.478 161.327Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.371 209.953C153.25 209.953 153.128 209.913 153.027 209.83C138.978 198.352 128.296 185.332 121.277 171.132C115.659 159.764 112.363 147.622 111.483 135.042C109.984 113.621 116.11 98.1294 116.172 97.9755C116.284 97.6967 116.601 97.5623 116.88 97.6742C117.158 97.7864 117.293 98.1033 117.181 98.382C117.12 98.534 111.078 113.833 112.572 135.017C113.949 154.553 122.205 183.244 153.715 208.987C153.948 209.178 153.983 209.52 153.792 209.753C153.685 209.885 153.528 209.953 153.371 209.953Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.378 290.289C130.142 290.289 129.926 290.135 129.856 289.898C129.771 289.61 129.936 289.308 130.225 289.223C167.336 278.335 186.688 258.552 196.388 243.873C206.882 227.992 208.639 214.544 208.656 214.41C208.692 214.112 208.967 213.9 209.262 213.937C209.56 213.973 209.772 214.245 209.736 214.543C209.719 214.68 207.929 228.381 197.296 244.473C187.496 259.303 167.958 279.287 130.531 290.267C130.48 290.282 130.428 290.289 130.378 290.289Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.189 68.0318C178.042 68.0318 177.896 67.9729 177.789 67.8567C156.563 44.8401 153.978 20.8241 155.548 4.7301C157.247 -12.7017 164.067 -24.8674 164.136 -24.9884C164.284 -25.2496 164.617 -25.3409 164.877 -25.1926C165.139 -25.0443 165.23 -24.7121 165.082 -24.451C165.014 -24.3318 158.295 -12.3328 156.626 4.88028C155.088 20.7413 157.65 44.4139 178.589 67.1189C178.792 67.3397 178.779 67.6839 178.558 67.8877C178.453 67.9841 178.321 68.0318 178.189 68.0318Z",
    fill: "white"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.483 416.064C178.54 416.183 187.471 412.864 189.442 411.039C202.561 398.895 228.6 377.752 230.467 358.946C230.785 355.734 217.035 350.518 215.506 347.281C207.547 341.827 204.447 340.429 199.427 331.527C184.606 305.245 233.842 268.156 187.115 244.933C152.888 227.922 120.489 235.491 133.26 180.187C146.031 124.883 117.898 15.9283 52.6447 45.5422C15.195 62.5378 42.0314 115.564 19.0146 147.866C-2.85736 178.561 6.90702 208.249 39.1337 233.885C71.3602 259.522 49.9986 271.89 34.6689 301.928C16.2545 338.01 73.712 354.063 100.871 359.211C122.741 363.357 175.633 388.669 174.483 416.064Z",
    fill: "url(#paint1_linear_492_558)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_492_558",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 40,
    width: 224,
    height: 377
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.483 416.063C178.54 416.182 187.471 412.863 189.442 411.038C202.561 398.894 228.6 377.751 230.467 358.945C230.785 355.734 217.035 350.517 215.506 347.28C207.546 341.826 204.447 340.428 199.427 331.526C184.606 305.244 233.842 268.155 187.115 244.932C152.888 227.921 120.489 235.49 133.26 180.186C146.031 124.882 117.898 15.9274 52.6446 45.5412C15.1949 62.5368 42.0313 115.563 19.0144 147.865C-2.85748 178.56 6.9069 208.248 39.1336 233.884C71.3601 259.521 49.9984 271.889 34.6687 301.927C16.2544 338.009 73.7119 354.062 100.871 359.21C122.741 363.356 175.633 388.668 174.483 416.063Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_492_558)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.202 386.518L209.697 385.812C100.827 309.522 49.0185 176.907 71.1075 31.0672L70.2538 30.9375C59.7855 100.055 66.2394 168.817 88.9185 229.788C112.761 293.888 154.354 348.084 209.202 386.518Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2945 316.046C61.1953 310.279 118.313 319.053 152.618 335.604L152.993 334.827C118.552 318.211 61.2059 309.403 25.1579 315.194L25.2945 316.046Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.002 371.298L188.673 370.755C176.243 355.345 172.081 334.242 176.303 308.033C179.399 288.816 186.847 267.353 198.44 244.237L197.668 243.851C186.036 267.044 178.561 288.592 175.451 307.896C171.188 334.357 175.411 355.688 188.002 371.298Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0358 221.009L86.7346 220.502C64.7982 190.249 27.7337 177.194 0.502939 171.568L0.328369 172.414C27.4097 178.008 64.2622 190.98 86.0358 221.009Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.415 137.516L68.2752 137.59C71.8658 95.6447 101.539 62.8994 118.907 47.1136L118.326 46.4746C100.865 62.3459 71.031 95.2774 67.415 137.516Z",
    fill: "#FCFDFE"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M434.484 387.51L26.5077 383.983V394.418C26.5077 397.25 28.2872 399.658 30.697 400.087L146.061 420.634C147.43 420.878 148.818 420.943 150.2 420.827L430.051 397.4C432.549 397.191 434.484 394.775 434.484 391.866V387.51Z",
    fill: "#BFC8D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M284.348 370.788L25.0462 389.877C20.4062 390.218 16.6334 386.589 16.6334 381.769V188.674C16.6334 183.854 20.4062 179.947 25.0462 179.947L34.2195 185.235L284.348 179.947C288.171 179.947 291.262 183.479 291.262 187.836V362.39C291.262 366.747 288.171 370.507 284.348 370.788Z",
    fill: "#BFC8D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M288.483 370.788L29.1807 389.877C24.5405 390.218 20.7679 386.589 20.7679 381.769V188.674C20.7679 183.854 24.5405 179.947 29.1807 179.947H288.483C292.305 179.947 295.396 183.479 295.396 187.836V362.39C295.396 366.747 292.305 370.507 288.483 370.788Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M280.405 358.482L38.892 375.062C35.116 375.321 32.0476 372.342 32.0476 368.408V199.353C32.0476 195.419 35.116 192.216 38.892 192.199L280.405 191.158C283.558 191.145 286.109 194.039 286.109 197.623V351.601C286.109 355.185 283.558 358.265 280.405 358.482Z",
    fill: "#D8DEE8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M124.548 208.065L59.3696 208.235L59.36 202.021L124.539 202.041L124.548 208.065Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M155.24 206.266L140.184 206.293L140.177 202.047L155.234 202.052L155.24 206.266Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.249 212.122L140.193 212.191L140.186 207.946L155.243 207.907L155.249 212.122Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M230.284 211.773L171.87 212.044L171.864 207.865L230.278 207.715L230.284 211.773Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M239.871 217.339L182.038 217.775L182.032 213.616L239.865 213.301L239.871 217.339Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M239.88 222.95L182.047 223.554L182.041 219.395L239.874 218.912L239.88 222.95Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M239.888 228.561L182.056 229.331L182.05 225.173L239.882 224.522L239.888 228.561Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M155.258 217.977L140.202 218.09L140.195 213.845L155.252 213.763L155.258 217.977Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M155.268 223.833L140.211 223.99L140.204 219.744L155.261 219.618L155.268 223.833Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M155.277 229.688L140.22 229.889L140.213 225.643L155.27 225.474L155.277 229.688Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M155.286 235.543L140.229 235.788L140.223 231.542L155.279 231.329L155.286 235.543Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M195.632 234.889L158.571 235.49L158.565 231.282L195.626 230.759L195.632 234.889Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M155.295 241.399L140.238 241.686L140.232 237.441L155.288 237.185L155.295 241.399Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M155.304 247.254L140.247 247.586L140.241 243.34L155.297 243.04L155.304 247.254Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M155.313 253.11L140.256 253.484L140.25 249.239L155.306 248.896L155.313 253.11Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M213.005 240.296L171.915 241.081L171.908 236.902L212.998 236.202L213.005 240.296Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M234.36 245.516L182.083 246.666L182.077 242.507L234.354 241.466L234.36 245.516Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M234.369 251.142L182.092 252.443L182.086 248.284L234.362 247.092L234.369 251.142Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M155.322 258.965L140.266 259.384L140.259 255.138L155.315 254.751L155.322 258.965Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M155.331 264.821L140.275 265.283L140.268 261.037L155.324 260.606L155.331 264.821Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M155.34 270.676L140.284 271.182L140.277 266.936L155.333 266.462L155.34 270.676Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M155.349 276.531L140.293 277.08L140.286 272.834L155.342 272.316L155.349 276.531Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M155.358 282.386L140.302 282.979L140.295 278.733L155.352 278.172L155.358 282.386Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M155.367 288.243L140.311 288.879L140.305 284.633L155.36 284.028L155.367 288.243Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M155.376 294.097L140.32 294.777L140.314 290.531L155.37 289.883L155.376 294.097Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M155.385 299.953L140.329 300.676L140.323 296.43L155.379 295.738L155.385 299.953Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M155.394 305.808L140.339 306.575L140.332 302.329L155.388 301.594L155.394 305.808Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M155.403 311.664L140.348 312.474L140.341 308.228L155.397 307.449L155.403 311.664Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M155.412 317.519L140.357 318.373L140.35 314.127L155.406 313.305L155.412 317.519Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M155.421 323.375L140.366 324.272L140.359 320.026L155.415 319.16L155.421 323.375Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M155.43 329.23L140.375 330.171L140.368 325.925L155.424 325.016L155.43 329.23Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M155.439 335.085L140.384 336.07L140.378 331.824L155.433 330.871L155.439 335.085Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M155.448 340.941L140.393 341.969L140.387 337.723L155.442 336.727L155.448 340.941Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M155.458 346.796L140.402 347.868L140.396 343.622L155.451 342.582L155.458 346.796Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M155.467 352.652L140.411 353.767L140.405 349.521L155.46 348.438L155.467 352.652Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M155.476 358.507L140.421 359.665L140.414 355.42L155.469 354.293L155.476 358.507Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M199.488 206.188L158.424 206.26L158.417 202.053L199.481 202.066L199.488 206.188Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M230.458 324.542L172.05 328.192L172.043 324.012L230.452 320.484L230.458 324.542Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M240.044 329.555L182.217 333.335L182.211 329.176L240.038 325.517L240.044 329.555Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M240.053 335.165L182.226 339.112L182.22 334.954L240.047 331.127L240.053 335.165Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M264.981 339.004L208.651 343.012L208.645 338.908L264.975 335.018L264.981 339.004Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M264.99 344.542L208.66 348.713L208.654 344.609L264.983 340.556L264.99 344.542Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M264.998 350.081L208.669 354.415L208.663 350.311L264.992 346.095L264.998 350.081Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M199.665 320.739L158.604 323.185L158.598 318.977L199.658 316.616L199.665 320.739Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M230.362 262.519L171.951 264.311L171.944 260.131L230.356 258.461L230.362 262.519Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M239.949 267.836L182.119 269.777L182.112 265.618L239.943 263.798L239.949 267.836Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M239.958 273.448L182.128 275.555L182.121 271.397L239.952 269.409L239.958 273.448Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M239.967 279.058L182.137 281.333L182.13 277.174L239.96 275.02L239.967 279.058Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M195.712 286.539L158.653 288.104L158.646 283.896L195.706 282.408L195.712 286.539Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M213.084 291.493L171.996 293.347L171.989 289.167L213.077 287.398L213.084 291.493Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M234.438 296.157L182.163 298.667L182.157 294.509L234.432 292.107L234.438 296.157Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M234.447 301.784L182.172 304.445L182.166 300.287L234.441 297.734L234.447 301.784Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M246.045 306.787L194.399 309.566L194.393 305.433L246.038 302.762L246.045 306.787Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M246.053 312.38L194.408 315.308L194.401 311.175L246.047 308.354L246.053 312.38Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M199.567 257.735L158.505 258.876L158.499 254.668L199.561 253.613L199.567 257.735Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M124.563 217.478L87.2562 217.745L87.2468 211.613L124.553 211.454L124.563 217.478Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M77.607 217.814L84.6334 217.763L84.624 211.623L77.5974 211.653L77.607 217.814Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M124.576 226.135L87.2698 226.56L87.2604 220.427L124.567 220.111L124.576 226.135Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6206 226.671L84.6471 226.591L84.6375 220.45L77.6111 220.51L77.6206 226.671Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M124.59 234.794L87.2835 235.376L87.2739 229.243L124.58 228.771L124.59 234.794Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6343 235.527L84.6607 235.418L84.6512 229.277L77.6247 229.366L77.6343 235.527Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M124.685 296.255L59.5102 299.22L59.5007 293.006L124.675 290.231L124.685 296.255Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M124.699 305.667L87.395 307.535L87.3856 301.403L124.69 299.644L124.699 305.667Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7463 308.019L84.7724 307.667L84.7628 301.526L77.7368 301.858L77.7463 308.019Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M124.712 314.325L87.4085 316.351L87.3991 310.218L124.703 308.302L124.712 314.325Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7601 316.875L84.786 316.494L84.7764 310.354L77.7505 310.714L77.7601 316.875Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M124.726 322.984L87.4223 325.167L87.4127 319.034L124.717 316.961L124.726 322.984Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7736 325.731L84.7996 325.32L84.7902 319.18L77.7642 319.57L77.7736 325.731Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M124.603 243.512L59.4261 244.805L59.4166 238.591L124.594 237.488L124.603 243.512Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M124.618 252.923L87.3121 253.834L87.3025 247.701L124.608 246.899L124.618 252.923Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M77.663 254.07L84.6892 253.898L84.6798 247.758L77.6534 247.909L77.663 254.07Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M124.631 261.582L87.3256 262.65L87.316 256.517L124.622 255.559L124.631 261.582Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6766 262.927L84.703 262.725L84.6934 256.585L77.6672 256.766L77.6766 262.927Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M124.658 279.012L87.3529 280.396L87.3435 274.264L124.649 272.988L124.658 279.012Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7042 280.754L84.7303 280.493L84.7209 274.353L77.6946 274.593L77.7042 280.754Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M124.671 287.67L87.3667 289.212L87.3571 283.079L124.662 281.646L124.671 287.67Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7179 289.61L84.744 289.32L84.7345 283.18L77.7084 283.449L77.7179 289.61Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M124.644 270.24L87.3392 271.466L87.3298 265.333L124.635 264.217L124.644 270.24Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6903 271.782L84.7165 271.552L84.707 265.411L77.6807 265.621L77.6903 271.782Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M124.739 331.641L59.5668 335.728L59.5572 329.514L124.73 325.617L124.739 331.641Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M124.754 341.052L87.4507 343.562L87.4411 337.429L124.744 335.028L124.754 341.052Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8022 344.212L84.8281 343.739L84.8186 337.599L77.7928 338.051L77.8022 344.212Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M124.767 349.71L87.4643 352.377L87.4548 346.245L124.758 343.687L124.767 349.71Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8159 353.068L84.8417 352.565L84.8323 346.425L77.8063 346.907L77.8159 353.068Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M124.781 358.369L87.478 361.194L87.4684 355.061L124.771 352.346L124.781 358.369Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8297 361.924L84.8553 361.392L84.8459 355.252L77.8201 355.763L77.8297 361.924Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M132.7 357.799L131.265 357.908L131.024 202.044L132.46 202.044L132.7 357.799Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M167.99 185.229C167.99 187.023 166.655 188.482 165.007 188.487C163.357 188.492 162.018 187.039 162.018 185.241C162.018 183.442 163.357 181.984 165.007 181.982C166.655 181.981 167.99 183.435 167.99 185.229Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M29.1798 389.877L287.17 370.885L288.483 370.788C290.237 370.659 291.832 369.792 293.05 368.477C274.485 367.461 262.953 360.873 255.515 354.065C240.577 340.394 243.168 326.912 227.059 317.924C206.967 306.712 191.168 320.918 175.922 306.902C166.678 298.404 171.216 292.067 159.842 279.368C147.245 265.303 139.043 270.031 126.383 257.372C110.375 241.366 118.381 228.913 104.592 217.421C87.8643 203.48 69.8241 216.384 53.9005 203.014C47.0324 197.247 43.2639 188.863 41.2961 179.947H29.1809C24.5407 179.947 20.7679 183.854 20.7679 188.674V381.769C20.7679 386.588 24.5399 390.218 29.1798 389.877Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M300.7 369.73L26.5076 389.822L146.061 411.115C147.43 411.359 148.818 411.424 150.2 411.308L434.484 387.51L305.062 369.866C303.614 369.669 302.154 369.623 300.7 369.73Z",
    fill: "url(#paint2_linear_492_558)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5165 389.995L294.79 373.019L365.438 382.572L139.132 400.719L66.5165 389.995Z",
    fill: "#D8DEE8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M301.248 107.83L65.196 100.217C57.1336 99.9567 50.5632 106.202 50.5632 114.167V344.274C50.5632 352.239 57.1336 358.294 65.196 357.801L301.248 343.37C307.952 342.961 313.36 336.785 313.36 329.575V121.276C313.36 114.066 307.952 108.046 301.248 107.83Z",
    fill: "url(#paint3_linear_492_558)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M65.196 353.221C59.7131 353.547 55.2523 349.424 55.2523 344.011V114.294C55.2523 108.882 59.7131 104.63 65.196 104.798L301.248 112.019C305.815 112.158 309.505 116.256 309.505 121.172V329.79C309.505 334.706 305.815 338.91 301.248 339.182L65.196 353.221Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M301.248 107.83L65.196 100.217C57.1338 99.9567 50.563 106.202 50.563 114.167V124.513L313.36 130.641V121.276C313.36 114.066 307.952 108.046 301.248 107.83Z",
    fill: "url(#paint4_linear_492_558)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5584 113.486C76.5584 116.069 74.4416 118.108 71.8257 118.04C69.2048 117.972 67.0765 115.816 67.0765 113.225C67.0765 110.634 69.2048 108.595 71.8257 108.672C74.4416 108.748 76.5584 110.904 76.5584 113.486Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0529 113.941C93.0529 116.508 90.9613 118.535 88.3768 118.468C85.7874 118.401 83.6846 116.259 83.6846 113.683C83.6846 111.107 85.7873 109.081 88.3768 109.156C90.9613 109.232 93.0529 111.374 93.0529 113.941Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M109.35 114.39C109.35 116.942 107.284 118.957 104.73 118.891C102.171 118.825 100.094 116.695 100.094 114.135C100.094 111.575 102.171 109.56 104.73 109.635C107.284 109.71 109.35 111.838 109.35 114.39Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.488 195.288C182.971 155.756 135.072 168.642 104.592 124.644C99.0807 116.688 95.3382 108.584 92.77 101.106L65.196 100.217C57.1337 99.9567 50.563 106.202 50.563 114.167V344.274C50.563 352.239 57.1335 358.294 65.1959 357.801L292.749 343.89C287.623 336.603 242.805 309.972 231.177 267.996C220.526 229.544 227.034 219.059 210.488 195.288Z",
    fill: "white"
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.225 267.086C178.73 267.275 168.277 264.852 159.011 260.052C149.007 254.877 140.629 247.12 134.821 237.62C129.192 228.41 126.207 217.847 126.207 207.102C126.207 173.4 154.836 146.727 189.226 147.623C222.764 148.497 249.443 175.392 249.443 207.596C249.443 239.8 222.764 266.481 189.225 267.086Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M244.234 207.575C244.234 237.038 219.883 261.318 189.226 261.811C179.303 261.97 169.92 259.625 161.71 255.354C152.607 250.624 144.977 243.531 139.71 234.895C134.744 226.752 131.889 217.26 131.889 207.124C131.889 176.413 157.859 152.141 189.226 152.897C219.883 153.636 244.234 178.111 244.234 207.575Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M224.388 198.849L224.372 214.497C224.367 215.996 223.763 217.428 222.681 218.485L209.054 231.848C207.955 232.922 206.463 233.533 204.91 233.531L184.284 233.532C184.284 233.532 170.118 247.209 161.71 255.354C152.607 250.624 144.977 243.531 139.71 234.895C148.198 226.748 162.73 212.75 162.73 212.75L162.647 192.463C162.641 190.923 163.279 189.45 164.415 188.376L178.492 175.021C179.61 173.965 181.121 173.386 182.69 173.412L199.022 173.692C200.371 173.714 201.59 174.527 202.107 175.748C202.618 176.974 202.333 178.365 201.38 179.281L185.817 194.191C184.432 195.516 184.426 197.692 185.812 199.044L191.383 204.491L192.919 205.989L198.461 211.412C199.832 212.75 202.053 212.755 203.421 211.425L218.782 196.518C219.723 195.602 221.137 195.338 222.368 195.849C223.593 196.359 224.393 197.542 224.388 198.849Z",
    fill: "url(#paint5_linear_492_558)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M270.845 312.42C270.845 315.81 268.094 318.663 264.692 318.793L110.747 324.67C106.926 324.816 103.821 322.012 103.821 318.406V293.923C103.821 290.318 106.926 287.318 110.747 287.223L264.692 283.414C268.094 283.33 270.845 286.01 270.845 289.4V312.42Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M380.045 230.666C380.045 230.666 378.131 229.611 377.575 228.272C377.018 226.933 377.01 224.849 378.905 223.754C380.799 222.659 376.83 221.637 377.513 220.748C378.196 219.858 380.438 218.979 380.438 218.979C380.438 218.979 381.796 224.657 381.458 225.508C381.119 226.36 379.294 226.463 380.992 228.898L380.045 230.666Z",
    fill: "url(#paint6_linear_492_558)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M318.92 422.988C318.77 423.087 316.048 426.77 314.817 429.178L311.431 427.359C311.431 427.359 313.339 426.679 314.299 422.988C315.258 419.297 318.92 422.988 318.92 422.988Z",
    fill: "url(#paint7_linear_492_558)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M310.018 431.382C310.018 431.382 312.141 432.1 313.024 432.164L313.113 432.171C313.613 432.207 314.097 431.988 314.396 431.586C314.918 430.886 315.673 429.826 315.687 429.53C315.709 429.076 314.483 428.145 313.391 427.742C312.299 427.339 312.043 426.799 310.018 425.181C307.993 423.563 304.572 421.643 302.97 423.121C301.368 424.6 302.848 428.283 310.018 431.382Z",
    fill: "url(#paint8_linear_492_558)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M304.144 423.356C305.903 424.056 306.434 426.036 309.486 428.045C311.218 429.184 313.354 430.231 314.878 430.924C315.289 430.343 315.677 429.742 315.687 429.53C315.709 429.077 314.483 428.146 313.391 427.743C312.299 427.34 312.043 426.8 310.018 425.182C307.993 423.564 304.572 421.644 302.97 423.122C302.562 423.499 302.355 424.019 302.39 424.636C302.707 423.782 303.248 422.999 304.144 423.356Z",
    fill: "url(#paint9_linear_492_558)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M288.637 190.181L288.741 197.216C288.771 199.28 290.502 200.793 292.605 200.596L296.427 200.238C296.956 203.559 297.847 206.73 299.06 209.713L295.92 211.812C294.116 213.018 293.526 215.361 294.603 217.045L298.272 222.78C299.347 224.461 304.18 225.256 305.978 224.048L306.446 221.641C308.62 224.1 311.078 226.294 313.771 228.182L312.144 231.196C311.127 233.08 311.78 235.293 313.602 236.139L319.803 239.015C321.619 239.858 327.375 239.721 328.387 237.84L326.481 234.238C329.673 235.156 333.024 235.723 336.49 235.904L336.536 239.021C336.567 241.067 338.266 242.552 340.331 242.34L347.356 241.619C349.414 241.408 351.056 239.584 351.026 237.544L350.979 234.436C354.406 233.558 357.698 232.323 360.815 230.776L362.431 233.332C363.48 234.99 369.452 235.578 371.205 234.381L373.476 230.095C375.225 228.901 375.796 226.594 374.752 224.938L373.08 222.286C375.646 219.902 377.97 217.268 380.006 214.432L382.939 215.823C384.711 216.663 389.848 216.886 390.835 215.032L391.295 207.677C392.28 205.828 391.647 203.646 389.88 202.802L386.797 201.331C387.88 198.182 388.645 194.912 389.059 191.563L392.739 191.218C394.76 191.029 396.372 189.238 396.343 187.217L396.241 180.328C396.211 178.307 394.549 176.818 392.529 177.001L388.631 177.355C388.031 174.183 387.097 171.156 385.866 168.305L389.335 165.976C391.072 164.808 391.639 162.516 390.602 160.853L390.947 153.985C389.908 152.319 383.769 153.105 382.027 154.269L378.376 156.709C376.307 154.443 373.989 152.41 371.464 150.644L373.593 146.688C374.585 144.844 373.947 142.648 372.168 141.78L369.409 138.178C367.625 137.308 362.054 138.74 361.057 140.586L358.869 144.641C355.917 143.787 352.824 143.229 349.625 143.003L349.558 138.487C349.528 136.448 347.836 134.931 345.778 135.1L338.751 135.675C336.685 135.843 335.034 137.638 335.065 139.684L335.132 144.212C331.925 144.974 328.828 146.054 325.873 147.409L327.039 142.571C325.974 140.882 320.163 141.598 318.377 142.773L312.278 146.784C310.486 147.963 309.9 150.291 310.971 151.982L313.264 155.607C310.738 157.829 308.427 160.288 306.374 162.944L306.416 160.547C304.587 159.674 298.407 161.056 297.385 162.93L293.897 169.326C292.872 171.204 293.53 173.432 295.364 174.302L299.019 176.035C297.835 179.153 296.962 182.398 296.437 185.73L292.391 186.098C290.288 186.289 288.606 188.117 288.637 190.181ZM314.779 192.001C314.55 176.523 327.069 162.872 342.654 161.517C358.145 160.17 370.818 171.495 371.045 186.803C371.271 202.112 358.968 215.743 343.48 217.259C327.897 218.784 315.009 207.479 314.779 192.001Z",
    fill: "url(#paint10_linear_492_558)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M293.351 189.891L293.455 196.926C293.486 198.99 295.217 200.503 297.32 200.307L301.142 199.949C301.671 203.269 302.561 206.44 303.775 209.424L300.634 211.523C298.83 212.728 298.241 215.071 299.318 216.755L302.986 222.491C304.061 224.172 306.391 224.554 308.19 223.347L311.161 221.351C313.334 223.81 315.792 226.004 318.485 227.892L316.858 230.906C315.841 232.79 316.494 235.004 318.316 235.849L324.517 238.725C326.333 239.568 328.625 238.725 329.637 236.844L331.195 233.948C334.387 234.866 337.738 235.433 341.205 235.615L341.251 238.732C341.281 240.777 342.981 242.263 345.045 242.051L352.071 241.329C354.128 241.118 355.77 239.294 355.74 237.254L355.694 234.147C359.12 233.268 362.413 232.033 365.529 230.486L367.146 233.042C368.195 234.701 370.467 235.073 372.221 233.877L378.191 229.805C379.94 228.611 380.51 226.304 379.466 224.648L377.795 221.996C380.361 219.613 382.685 216.979 384.721 214.143L387.653 215.533C389.425 216.373 391.661 215.551 392.648 213.698L396.01 207.388C396.995 205.538 396.362 203.356 394.595 202.513L391.512 201.041C392.595 197.892 393.36 194.622 393.773 191.273L397.454 190.928C399.474 190.739 401.087 188.948 401.057 186.927L400.955 180.038C400.925 178.017 399.264 176.527 397.243 176.711L393.346 177.065C392.746 173.893 391.812 170.866 390.58 168.015L394.049 165.686C395.787 164.519 396.354 162.226 395.316 160.563L391.777 154.889C390.738 153.223 388.484 152.815 386.742 153.979L383.091 156.419C381.021 154.153 378.704 152.12 376.178 150.354L378.307 146.398C379.299 144.555 378.662 142.358 376.883 141.49L370.809 138.529C369.024 137.659 366.769 138.45 365.772 140.297L363.583 144.351C360.631 143.497 357.539 142.939 354.339 142.713L354.272 138.197C354.242 136.158 352.551 134.641 350.493 134.81L343.465 135.385C341.4 135.554 339.749 137.348 339.779 139.393L339.846 143.922C336.639 144.684 333.542 145.764 330.588 147.119L328.253 143.415C327.188 141.726 324.877 141.308 323.091 142.483L316.992 146.494C315.2 147.672 314.615 150 315.684 151.692L317.978 155.317C315.452 157.538 313.141 159.998 311.088 162.654L307.263 160.828C305.434 159.955 303.121 160.766 302.099 162.64L298.611 169.036C297.586 170.914 298.244 173.142 300.078 174.012L303.734 175.745C302.549 178.863 301.676 182.108 301.152 185.44L297.105 185.808C295.002 185.999 293.321 187.827 293.351 189.891ZM319.494 191.711C319.265 176.233 331.783 162.582 347.369 161.227C362.859 159.88 375.533 171.205 375.759 186.513C375.986 201.822 363.683 215.453 348.194 216.969C332.611 218.494 319.723 207.19 319.494 191.711Z",
    fill: "url(#paint11_linear_492_558)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M339.069 323.446C333.631 334.389 328.087 347.542 323.506 362.782C316.68 385.484 314.066 405.907 313.23 422.114C315.173 422.916 317.116 423.719 319.059 424.521C322.877 422.088 328.478 417.804 332.608 410.851C339.378 399.454 334.599 393.675 340.102 379.967C345.436 366.679 352.196 366.457 358.052 352.007C361.546 343.388 362.345 335.561 362.499 330.459C354.689 328.121 346.879 325.784 339.069 323.446Z",
    fill: "url(#paint12_linear_492_558)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M349.744 326.641C351.85 332.087 351.681 336.181 350.869 339.18C348.167 349.165 337.503 350.248 334.964 361.413C333.26 368.906 337.575 370.563 335.306 378.345C332.898 386.602 327.601 386.24 324.703 394.763C322.424 401.463 324.852 404.174 323.848 413.576C323.5 416.83 322.855 419.79 322.079 422.43C325.487 419.87 329.471 416.132 332.608 410.851C339.378 399.454 334.599 393.675 340.102 379.967C345.436 366.678 352.196 366.456 358.052 352.007C361.546 343.388 362.345 335.56 362.499 330.458C358.247 329.186 353.996 327.913 349.744 326.641Z",
    fill: "url(#paint13_linear_492_558)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M424.556 403.657C424.556 403.657 425.995 404.198 426.633 406.208C427.271 408.217 426.227 416.569 425.318 418.621C424.41 420.674 421.732 420.184 420.952 418.621C420.171 417.059 421.281 406.004 421.281 406.004L424.556 403.657Z",
    fill: "url(#paint14_linear_492_558)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M339.924 328.406C346.25 336.985 350.619 344.419 353.435 349.613C359.385 360.587 360.747 365.876 367.761 376.074C374.256 385.518 378.543 388.914 380.293 390.217C384.514 393.36 387.998 394.769 396.965 398.161C404.801 401.124 413.1 404.193 421.839 407.336C423.383 407.509 424.032 406.843 424.457 405.442C424.313 398.767 422.304 394.692 420.638 392.28C417.082 387.132 413.392 387.106 402.386 379.308C396.517 375.151 393.533 373.002 391.059 369.602C389.869 367.966 387.921 364.926 384.834 353.453C383.569 348.752 382.048 342.394 380.766 334.707C367.152 332.607 353.538 330.507 339.924 328.406Z",
    fill: "url(#paint15_linear_492_558)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M303.085 228.627C303.085 228.627 304.168 226.398 301.624 224.394C299.079 222.39 294.218 219.635 294.603 215.787C294.603 215.787 297.23 220.206 298.927 219.807C300.624 219.409 301.767 220.384 301.767 220.384C301.767 220.384 305.737 222.644 305.621 226.975C305.505 231.307 305.505 231.307 305.505 231.307L303.085 228.627Z",
    fill: "url(#paint16_linear_492_558)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M301.871 227.626C303.36 227.387 304.849 227.148 306.338 226.908C307.615 228.813 309.399 231.835 310.724 235.818C313.717 244.816 311.422 249.854 313.201 255.294C314.659 259.75 319.123 265.304 332.826 269.403C332.727 278.106 332.628 286.809 332.528 295.511C326.911 294.677 317.866 292.449 309.225 285.822C304.219 281.983 298.795 277.822 296.783 270.686C294.244 261.681 298.005 251.006 299.477 246.828C300.319 244.437 301.954 240.384 302.228 234.592C302.366 231.673 302.115 229.252 301.871 227.626Z",
    fill: "url(#paint17_linear_492_558)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M331.786 269.083C336.501 270.01 343.02 270.724 350.653 269.824C363.933 268.259 373.559 262.636 378.541 259.189C383.983 271.063 384.097 279.865 383.138 285.779C382.432 290.138 381.359 291.6 381.262 296.477C381.1 304.689 384.036 305.933 385.416 316.606C386.552 325.392 384.919 327.306 387.484 330.964C389.324 333.588 391.767 334.888 393.22 338.99C393.701 340.349 394.898 343.729 393.625 344.825C391.587 346.58 386.525 339.617 377.079 338.668C372.041 338.162 371.27 339.92 366.048 338.924C360.348 337.838 360.743 335.644 355.402 334.563C350.107 333.493 348.5 335.402 340.395 334.435C336.984 334.028 335.279 333.825 334.216 332.879C330.777 329.821 333.619 323.736 334.238 314.169C334.848 304.733 332.506 304.104 331.544 290.054C331.204 285.092 330.999 277.912 331.786 269.083Z",
    fill: "url(#paint18_linear_492_558)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M377.592 230.41C378.661 229.213 379.73 228.015 380.799 226.818C385.299 229.244 392.175 233.668 398.412 241.235C403.078 246.898 407.198 251.896 407.642 259.149C408.277 269.546 400.916 277.328 397.489 280.951C390.735 288.091 382.945 291.076 378.49 292.363C369.861 273.212 371.143 265.732 374.198 262.538C375.898 260.761 378.191 260.265 380.293 256.966C383.218 252.377 382.7 247.186 382.371 243.895C381.766 237.842 379.398 233.22 377.592 230.41Z",
    fill: "url(#paint19_linear_492_558)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M351.684 259.843C351.439 261.147 351.288 263.96 353.012 266.195C354.521 268.152 356.829 268.744 357.754 268.991C359.989 269.587 361.196 269.104 361.316 269.488C361.583 270.339 356.101 274.116 349.757 273.879C346.029 273.74 342.273 272.225 342.312 271.027C342.355 269.683 347.14 269.835 348.328 267.051C349.087 265.272 348.041 263.081 346.905 261.374C347.934 260.177 350.653 261.043 351.684 259.843Z",
    fill: "url(#paint20_linear_492_558)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M347.087 258.677C346.699 257.597 347.13 256.142 348.185 255.525C349.094 254.994 350.157 255.279 350.795 255.449C352.643 255.944 354.67 257.519 354.95 259.374C355.116 260.475 353.484 261.996 353.214 262.279C352.909 262.598 352.542 262.606 352.147 262.783C351.599 263.029 350.738 263.424 349.326 264.095C349.349 263.743 349.353 263.299 349.294 262.793C349.272 262.598 349.175 261.834 348.886 261.12C348.307 259.689 347.454 259.702 347.087 258.677Z",
    fill: "url(#paint21_linear_492_558)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M351.134 263.773C351.134 263.773 349.365 265.134 347.077 264.078C345.032 263.135 346.173 258.596 347.812 258.175C348.36 258.035 349.294 258.25 349.956 258.723C350.348 259.003 350.438 259.227 351.086 259.672C351.684 260.084 351.89 260.087 352.036 260.319C352.218 260.609 352.242 261.157 351.409 262.293C351.933 262.067 352.461 262.107 352.752 262.391C352.798 262.436 352.912 262.584 352.947 262.756C353.075 263.376 352.373 263.833 351.134 263.773Z",
    fill: "url(#paint22_linear_492_558)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M378.746 328.235C374.738 327.46 373.23 331.294 369.34 330.629C363.932 329.704 364.496 321.892 358.224 318.144C351.037 313.851 343.849 320.253 339.069 316.605C336.333 314.518 334.502 309.226 338.043 295.398C338.102 294.32 338.268 289.203 334.451 284.795C330.115 279.787 324.078 279.667 323.164 279.664C313.449 280.261 304.266 275.666 299.391 267.693C297.665 264.869 296.717 262.007 296.247 259.328C295.762 263.019 295.742 266.993 296.783 270.685C298.795 277.822 304.22 281.982 309.225 285.821C317.627 292.264 326.399 294.545 332.043 295.434C333.13 304.471 334.758 306.116 334.238 314.168C333.619 323.735 330.777 329.82 334.216 332.879C335.279 333.824 336.985 334.028 340.395 334.434C348.5 335.401 350.107 333.492 355.402 334.563C360.743 335.643 360.348 337.837 366.048 338.924C371.271 339.919 372.041 338.161 377.079 338.667C386.525 339.617 391.587 346.579 393.626 344.824C394.354 344.197 394.272 342.822 393.98 341.505C391.452 340.655 389.641 339.483 388.324 338.325C383.821 334.368 383.226 329.101 378.746 328.235Z",
    fill: "url(#paint23_linear_492_558)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M235.703 101.418L235.781 106.723C235.804 108.28 237.109 109.421 238.695 109.272L241.577 109.002C241.976 111.506 242.648 113.897 243.563 116.147L241.194 117.73C239.834 118.638 239.39 120.405 240.202 121.675L242.968 126C243.778 127.268 247.423 127.867 248.779 126.956L249.132 125.141C250.771 126.995 252.624 128.649 254.655 130.073L253.428 132.346C252.661 133.767 253.154 135.436 254.528 136.073L259.203 138.242C260.573 138.877 264.913 138.774 265.676 137.356L264.239 134.64C266.646 135.332 269.173 135.759 271.787 135.896L271.822 138.247C271.845 139.789 273.126 140.909 274.683 140.75L279.981 140.206C281.532 140.046 282.77 138.671 282.748 137.133L282.713 134.789C285.296 134.127 287.779 133.196 290.129 132.029L291.348 133.956C292.139 135.207 296.642 135.65 297.965 134.748L299.677 131.515C300.995 130.616 301.426 128.875 300.639 127.627L299.378 125.627C301.313 123.83 303.066 121.844 304.601 119.705L306.812 120.754C308.148 121.387 312.023 121.555 312.767 120.158L313.113 114.612C313.856 113.217 313.379 111.571 312.047 110.935L309.722 109.826C310.538 107.451 311.115 104.986 311.427 102.46L314.202 102.2C315.726 102.058 316.942 100.707 316.92 99.1829L316.843 93.9884C316.82 92.4644 315.567 91.3412 314.043 91.4797L311.105 91.7465C310.652 89.3548 309.948 87.0718 309.019 84.9223L311.635 83.1659C312.945 82.2858 313.373 80.5571 312.59 79.3028L312.851 74.1246C312.068 72.8682 307.439 73.4606 306.125 74.3385L303.372 76.1784C301.811 74.4693 300.064 72.9364 298.159 71.6049L299.765 68.6218C300.513 67.2319 300.032 65.5753 298.69 64.9213L296.61 62.2048C295.264 61.5488 291.064 62.6283 290.312 64.021L288.662 67.0781C286.436 66.4344 284.104 66.0136 281.691 65.8432L281.641 62.4381C281.618 60.9002 280.342 59.7566 278.791 59.8837L273.491 60.3172C271.934 60.4446 270.689 61.7979 270.712 63.3403L270.763 66.7549C268.344 67.3299 266.009 68.1438 263.781 69.1656L264.66 65.5175C263.857 64.2437 259.475 64.7841 258.128 65.6699L253.529 68.6945C252.178 69.5831 251.736 71.3385 252.543 72.6138L254.273 75.3477C252.368 77.0226 250.626 78.8771 249.077 80.88L249.109 79.0725C247.73 78.4142 243.07 79.4563 242.299 80.8699L239.668 85.6925C238.896 87.1087 239.392 88.7889 240.775 89.4449L243.531 90.7514C242.638 93.1026 241.98 95.5498 241.584 98.0623L238.533 98.3395C236.947 98.4834 235.68 99.8617 235.703 101.418ZM255.416 102.791C255.243 91.1197 264.683 80.8255 276.435 79.8038C288.116 78.7885 297.673 87.3277 297.844 98.8714C298.015 110.415 288.737 120.694 277.058 121.837C265.307 122.986 255.589 114.462 255.416 102.791Z",
    fill: "url(#paint24_linear_492_558)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M239.258 101.199L239.336 106.504C239.359 108.06 240.664 109.201 242.25 109.053L245.133 108.783C245.531 111.287 246.203 113.678 247.118 115.928L244.75 117.51C243.389 118.419 242.945 120.186 243.757 121.456L246.523 125.781C247.334 127.049 249.091 127.337 250.447 126.426L252.687 124.922C254.326 126.776 256.18 128.43 258.21 129.854L256.983 132.127C256.216 133.548 256.709 135.216 258.083 135.854L262.758 138.023C264.128 138.658 265.856 138.023 266.619 136.604L267.795 134.421C270.201 135.113 272.728 135.54 275.342 135.677L275.377 138.028C275.4 139.57 276.681 140.69 278.238 140.53L283.536 139.986C285.087 139.827 286.325 138.451 286.303 136.913L286.268 134.57C288.852 133.908 291.334 132.977 293.684 131.81L294.903 133.737C295.694 134.988 297.408 135.269 298.731 134.367L303.232 131.296C304.551 130.396 304.981 128.656 304.194 127.407L302.933 125.408C304.868 123.611 306.621 121.624 308.156 119.486L310.367 120.534C311.703 121.168 313.39 120.548 314.134 119.151L316.668 114.392C317.411 112.997 316.934 111.352 315.601 110.716L313.277 109.607C314.093 107.232 314.67 104.766 314.982 102.241L317.757 101.981C319.281 101.838 320.497 100.487 320.475 98.9634L320.398 93.7689C320.375 92.2448 319.122 91.1218 317.599 91.2602L314.66 91.5272C314.207 89.1355 313.503 86.8525 312.574 84.7029L315.19 82.9464C316.5 82.0665 316.928 80.3376 316.145 79.0835L313.477 74.8052C312.693 73.5488 310.994 73.2413 309.68 74.1192L306.927 75.9591C305.366 74.25 303.619 72.7171 301.714 71.3854L303.32 68.4023C304.068 67.0124 303.587 65.3558 302.246 64.7018L297.666 62.4686C296.32 61.8126 294.619 62.4088 293.867 63.8017L292.217 66.8587C289.991 66.2149 287.659 65.7942 285.247 65.6236L285.196 62.2185C285.173 60.6806 283.898 59.537 282.346 59.6639L277.046 60.0975C275.489 60.225 274.244 61.5781 274.267 63.1204L274.318 66.535C271.899 67.11 269.564 67.9239 267.336 68.9456L265.576 66.1532C264.773 64.8793 263.03 64.5642 261.683 65.45L257.084 68.4747C255.733 69.3632 255.292 71.1186 256.098 72.3939L257.828 75.1278C255.923 76.8027 254.181 78.6572 252.633 80.6601L249.748 79.2833C248.369 78.625 246.625 79.2362 245.854 80.6499L243.224 85.4725C242.451 86.8886 242.947 88.5689 244.33 89.2248L247.087 90.5314C246.193 92.8826 245.535 95.3298 245.14 97.8423L242.088 98.1195C240.502 98.2641 239.235 99.6426 239.258 101.199ZM258.971 102.572C258.798 90.9003 268.238 80.6062 279.99 79.5846C291.671 78.5691 301.228 87.1084 301.398 98.652C301.569 110.196 292.292 120.474 280.613 121.617C268.862 122.767 259.144 114.243 258.971 102.572Z",
    fill: "url(#paint25_linear_492_558)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_492_558",
    x1: 160.862,
    y1: 97.6069,
    x2: 151.613,
    y2: 319.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#F9A025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5917,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_492_558",
    x1: 107.059,
    y1: 369.698,
    x2: 135.907,
    y2: 122.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_492_558",
    x1: 26.5076,
    y1: 390.519,
    x2: 434.484,
    y2: 390.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_492_558",
    x1: 269.256,
    y1: 47.3237,
    x2: 13.3717,
    y2: 559.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_492_558",
    x1: 126.417,
    y1: -100.164,
    x2: 170.563,
    y2: 76.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_492_558",
    x1: 204.383,
    y1: 178.31,
    x2: 132.745,
    y2: 329.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_492_558",
    x1: 379.206,
    y1: 228.55,
    x2: 378.153,
    y2: 250.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_492_558",
    x1: 311.431,
    y1: 425.263,
    x2: 318.92,
    y2: 425.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_492_558",
    x1: 302.385,
    y1: 427.383,
    x2: 315.687,
    y2: 427.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_492_558",
    x1: 310.894,
    y1: 422.541,
    x2: 309.423,
    y2: 425.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_492_558",
    x1: 400.011,
    y1: 90.8723,
    x2: 274.324,
    y2: 311.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_492_558",
    x1: 402.102,
    y1: 92.1188,
    x2: 278.373,
    y2: 309.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_492_558",
    x1: 345.935,
    y1: 349.631,
    x2: 305.232,
    y2: 420.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_492_558",
    x1: 350.633,
    y1: 352.338,
    x2: 309.93,
    y2: 422.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_492_558",
    x1: 420.673,
    y1: 411.82,
    x2: 426.829,
    y2: 411.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_492_558",
    x1: 396.727,
    y1: 334.342,
    x2: 369.534,
    y2: 395.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_492_558",
    x1: 299.992,
    y1: 224.763,
    x2: 298.966,
    y2: 245.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_492_558",
    x1: 311.377,
    y1: 260.517,
    x2: 340.451,
    y2: 341.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_492_558",
    x1: 339.891,
    y1: 250.334,
    x2: 368.965,
    y2: 331.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_492_558",
    x1: 379.175,
    y1: 236.304,
    x2: 408.249,
    y2: 317.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_492_558",
    x1: 354.255,
    y1: 279.099,
    x2: 347.559,
    y2: 254.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_492_558",
    x1: 351.344,
    y1: 270.769,
    x2: 350.87,
    y2: 256.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_492_558",
    x1: 350.29,
    y1: 259.924,
    x2: 342.891,
    y2: 277.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_492_558",
    x1: 307.887,
    y1: 201.179,
    x2: 352.444,
    y2: 325.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_492_558",
    x1: 319.686,
    y1: 26.5334,
    x2: 224.91,
    y2: 192.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_492_558",
    x1: 321.263,
    y1: 27.4728,
    x2: 227.963,
    y2: 191.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.a7e30de32190282f793a716c1df0b541.svg";
export { ForwardRef as ReactComponent };